import Vue from 'vue'
import Vuex from 'vuex'
import router from '../router'
import {service} from '../utils/axios'

Vue.use(Vuex)
// 从 localStorage 读取初始状态（解决刷新丢失问题）
const savedState = localStorage.getItem('insuranceStore')
const initialState = savedState
  ? JSON.parse(savedState)
  : {
    productList: [],
    currentProduct: null,
    isLoggedIn: true // 登录状态
  }
export default new Vuex.Store({
  state: initialState,
  mutations: {
    SET_PRODUCT_LIST (state, list) {
      state.productList = list
    },
    SET_CURRENT_PRODUCT (state, product) {
      state.currentProduct = product
    },
    SET_USER_INFO (state, user) {
      state.userInfo = JSON.stringify(user)
      localStorage.setItem('user', JSON.stringify(user))
    }, // 存储用户信息
    SET_LOGIN_STATUS (state, status) { // 新增：更新登录状态
      state.isLoggedIn = status
      localStorage.setItem('insuranceStore', JSON.stringify(state))
    }
  },
  actions: {
    async checkToken ({ state, commit }) {
      const savedState = localStorage.getItem('insuranceStore')
      if (!savedState) return // 未登录，无需检查

      const { userInfo } = JSON.parse(savedState)
      if (!userInfo.token) return

      try {
        // 调用检查 token 接口（假设接口需要传递 token）
        const token = JSON.parse(localStorage.getItem('user')).token
        const res = await service.get(`/website/checkToken?token=${token}`) // 等待 token 检查完成
        if (!res.success) { // token 过期
          // 清除 Vuex 状态
          commit('SET_USER_INFO', null)
          commit('SET_LOGIN_STATUS', false)
          // 清除 localStorage
          localStorage.removeItem('insuranceStore')
          router.push('/') // 跳转到首页
        }
      } catch (error) {
        console.error('检查 token 失败:', error)
      }
    },

    fetchProductList ({ commit }) {
      // 模拟API请求
      const products = [
        {
          id: 1,
          name: '个人意外险',
          price: 199,
          desc: '全面保障意外伤害风险'
        },
        {
          id: 2,
          name: '健康医疗险',
          price: 399,
          desc: '住院、门诊全方位医疗保障'
        },
        {
          id: 3,
          name: '旅行保险',
          price: 99,
          desc: '境内外旅行意外伤害及医疗保障'
        }
      ]
      commit('SET_PRODUCT_LIST', products)
    },
    fetchProductDetail ({ commit }, id) {
      // 模拟API请求
      const product = {
        id: id,
        name: '个人意外险',
        price: 199,
        desc: '全面保障意外伤害风险',
        coverage: '意外伤害身故/伤残、意外医疗、住院津贴',
        duration: '1年',
        ageRange: '18-65周岁'
      }
      commit('SET_CURRENT_PRODUCT', product)
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js